/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.ursascheduler.SchedulerGranularity
*/
export var SchedulerGranularity;
(function (SchedulerGranularity) {
    SchedulerGranularity["SECONDS"] = "SECONDS";
    SchedulerGranularity["MINUTES"] = "MINUTES";
    SchedulerGranularity["HOURS"] = "HOURS";
})(SchedulerGranularity || (SchedulerGranularity = {}));
//# sourceMappingURL=SchedulerGranularity.js.map